import React from 'react'
import { connect } from 'react-redux'
import CouponForm from './CouponForm'

import {
  clear_coupon,
} from '../actions'

const mapStateToProps = state => {
  return {

  }
}
const mapDispatchToProps = dispatch => {
  return {
    clearCoupon: () => dispatch( clear_coupon() ),
  }
}

class ConnectedCouponEdit extends React.Component {
  componentWillMount() {
    this.props.clearCoupon()
  }

  render(){
    const {coupon_id} = this.props.match.params

    return <CouponForm actionName="update" coupon_id={coupon_id}/>
  }
}

const CouponEdit = connect(mapStateToProps, mapDispatchToProps)(ConnectedCouponEdit)
export default CouponEdit



// WEBPACK FOOTER //
// ./src/js/components/CouponEdit.js